import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 90524 44051"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#2b2a29;stroke-width:995.488}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970274128496">
        <path
          d="M72353 498H46644l17528 21527-17528 21528h25709l17530-21528z"
          className="fill stroke1"
          style={{
            strokeWidth: 995.488,
          }}
        />
        <path
          d="M39688 498h-8394l17531 21527-17531 21528h8394l17528-21528z"
                    className="fill stroke1"
          style={{
            strokeWidth: 995.488,
          }}

        />
        <path
          d="M24515 498h-8393l17531 21527-17531 21528h8393l17529-21528z"
                    className="fill stroke1"
          style={{
            strokeWidth: 995.488,
          }}

        />
        <path
          d="M9438 498H1046l17530 21527L1046 43553h8392l17529-21528z"
                    className="fill stroke1"
          style={{
            strokeWidth: 995.488,
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
